import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUser, PasswordSecurity, PasswordSecurityErrorMessage } from '@core/services/auth/auth.model';
import { AuthService } from '@core/services/auth/auth.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { NavigationService } from '@core/services/navigation.service';
import { mustNotMatchValidator } from '@shared/directives/must-not-match.directive';

@Component({
  selector: 'Teranet-PasswordSecurity',
  templateUrl: './password-security.component.html'
})
export class PasswordSecurityComponent implements OnInit {
  passwordSecurityForm: FormGroup;
  passwordSecurityModel: PasswordSecurity;
  questionList: any[];
  errorMessage: Array<string> = [];
  passwordSecurityErrorMessage = PasswordSecurityErrorMessage;
  isError: boolean;
  isChangeSaved: boolean;
  isChangePasswordForced: string;
  private user = new CurrentUser();

  constructor(public authService: AuthService,
    private localStorageService: LocalStorageService, private router: Router, private fb: FormBuilder,
    private navigation: NavigationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.passwordSecurityModel = new PasswordSecurity();
    this.passwordSecurityModel.answerList = [
      { passwordSecurityQuestionId: 0, answer: "", setId: 1 },
      { passwordSecurityQuestionId: 0, answer: "", setId: 2 },
      { passwordSecurityQuestionId: 0, answer: "", setId: 3 }];
    this.passwordSecurityForm = this.fb.group(
      {
        'password': new FormControl('', Validators.required),
        'setOneQuestion': new FormControl('', Validators.compose([Validators.required, Validators.min(1)])),
        'setOneAnswer': new FormControl('', Validators.compose([Validators.required, Validators.minLength(4)])),
        'setTwoQuestion': new FormControl('', Validators.compose([Validators.required, Validators.min(1)])),
        'setTwoAnswer': new FormControl('', Validators.compose([Validators.required, Validators.minLength(4)])),
        'setThreeQuestion': new FormControl('', Validators.compose([Validators.required, Validators.min(1)])),
        'setThreeAnswer': new FormControl('', Validators.compose([Validators.required, Validators.minLength(4)]))
      },
      {
        validators: [mustNotMatchValidator('setOneAnswer', 'setTwoAnswer'),
        mustNotMatchValidator('setOneAnswer', 'setThreeAnswer'),
        mustNotMatchValidator('setTwoAnswer', 'setThreeAnswer'),
        mustNotMatchValidator('setThreeAnswer', 'setOneAnswer')]
      });
    this.BindQuestionList();
    this.activatedRoute.queryParams.subscribe(params => {
      this.isChangePasswordForced = params['isChangePasswordForced'];
    });
  }

  onCancel() {
    this.navigation.back();
  }

  BindQuestionList() {
    this.questionList = [];
    this.authService.getPasswordSecurityQuestions().subscribe(data => {
      for (let key in data) {
        this.questionList.push({ label: data[key].question, value: data[key].id });
      }
    });
  }

  OnSubmit() {
    this.isError = null;
    this.errorMessage = [];
    if (this.passwordSecurityForm.valid) {
      this.authService.setPaswordSecurityAnswer(this.passwordSecurityModel).subscribe(x => {
        this.isError = false;
        this.isChangeSaved = true;
      },
        (err: HttpErrorResponse) => {
          this.isError = true;
          if (err.error.title == "One or more validation errors occurred.") {
            Object.entries(err.error.errors).forEach(
              ([key, value]) =>
                this.errorMessage.push(this.replacePropertyName(key) + " : " + value)
            );
          }
          else {
            this.errorMessage.push(this.replacePropertyName(err.error));
          }
        });
    }
  }

  onOk() {
    if (this.isChangePasswordForced === 'true') {
      this.router.navigateByUrl('/updatepassword');
    }
    else {
      this.user = this.localStorageService.getItem("currentUser");
      this.user.authenticated = true;
      this.localStorageService.setItem('currentUser', this.user);
      this.authService.currentUserSubject.next(this.user);
      this.router.navigateByUrl('/dashboard');
    }
  }

  replacePropertyName(name) {
    if (name == "AnswerList[0].Answer") {
      return "Answer 1";
    }
    else if (name == "AnswerList[1].Answer") {
      return "Answer 2";
    }
    else if (name == "AnswerList[2].Answer") {
      return "Answer 3";
    }
    else {
      return name;
    }
  }

}
